import dsBridge from "@/utils/mobilePhone/dsbridge.js";
import { Message } from "element-ui";
const originalCall = dsBridge.call;
dsBridge.call = function (method, params, callback) {
  if (typeof callback === "function") {
    const wrappedCallback = (result) => {
      if (result?.code !== 200) {
        Message.error(result.message);
        console.log("安卓报错", result, method);
      }
      callback(result);
    };
    return originalCall.call(this, method, params, wrappedCallback);
  }
  return originalCall.apply(this, arguments);
};
dsBridge.register("rlkj", {
  tag: "rlkj",
  getProjectId: function () {
    return {
      project_id: window.location.href.split("/")[5],
      project_name: window.location.href.split("/")[6],
    };
  },
});
// 基础------------------------------------------------------
// 判断是否安卓
export const getIsAndroid = () => {
  return dsBridge.hasNativeMethod("rlkj.getUserInfo");
};

//判断是否是安卓离线
export const isAndroidOnline = () => {
  return getIsAndroid() && window.location.href.includes("127.0.0.1");
};

// 返回
export const qrCodeOpen = () => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.qrCodeOpen", (result) => {
      resolve(result);
    });
  });
};
export const goBack = () => {
  dsBridge.call("rlkj.goBack");
};

// 退出登录
export const loginOut = () => {
  dsBridge.call("rlkj.loginOut");
};

// 打开url
export const openUrl = (url) => {
  dsBridge.call("rlkj.openUrl", url);
};
export const startDetection = (projectId) => {
  dsBridge.call("rlkj.startDetection", projectId);
};

export const openUrlPortrait = (url) => {
  dsBridge.call("rlkj.openUrlPortrait", url);
};

// 获取用户信息
export const getUserInfo = () => {
  return { data: dsBridge.call("rlkj.getUserInfo") };
};

// 获取列表配置
export const getSelectConfig = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getSelectConfig", params, (result) => {
      resolve(result);
    });
  });
};

// 下载项目到本地
export const downloadProject = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.downloadProject", params, (result) => {
      resolve(result);
    });
  });
};

// 上传云端
export const uploadCloud = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.uploadCloud", params, (result) => {
      resolve(result);
    });
  });
};

// 安卓拍照
export const takePhotoAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.takePicture", params, (result) => {
      resolve(result);
    });
  });
};

// 获取加载图片
export const getLoadImage = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.loadImage", params, (result) => {
      resolve(result);
    });
  });
};
// 项目------------------------------------------------------
// 获取项目列表
export const getProjectList = (params, callback) => {
  dsBridge.call("rlkj.getProjectList", params, (result) => {
    callback(result);
  });
};

// 项目详情
export const projectDetailAndroid = (id) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.projectDetail", id, (result) => {
      resolve(result);
    });
  });
};

// 公用------------------------------------------------------
// 配置列表
export const getInvestigateConfig = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestigateConfig", params, (result) => {
      resolve(result);
    });
  });
};

// 建模 检测------------------------------------------------------
// 获取模型状态
export const getModelEditStatus = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getModelEditStatus", params, (result) => {
      resolve(result);
    });
  });
};

// 建模保存
export const saveModelAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.saveModel", data, (result) => {
      resolve(result);
    });
  });
};

// 获取所有的楼层相关数据--v2
export const getFloorData = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getFloorData", params, (result) => {
      resolve(result);
    });
  });
};

// 删除楼层检测
export const floorHeightDeleteAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.floorHeightDelete", data, (result) => {
      resolve(result);
    });
  });
};

// 检测--状态数据
export const DetectionStatusListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.DetectionStatusListAndroid", params, (result) => {
      resolve(result);
    });
  });
};

// 检测-汇总上报异常列表
export const reportModelListAndroid = (params) => {
  return new Promise((resolve) => {
    // dsBridge.call("rlkj.reportModelList", params, (result) => {
    //   resolve(result);
    // });
    setTimeout(() => {
      resolve({ code: 200, message: "success", data: [], success: true });
    }, 0);
  });
};

// 生成表格--详情
export const DetectionTableListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.DetectionTableList", params, (result) => {
      resolve(result);
    });
  });
};

// 检查
export const detectionAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.detection", data, (result) => {
      resolve(result);
    });
    // setTimeout(() => {
    //   resolve({ code: 200, message: "success", data: [], success: true });
    // }, 0);
  });
};

// 删除楼层检测
export const delFloorDetectionAndroid = () => {
  return new Promise((resolve) => {
    // dsBridge.call("rlkj.delFloorDetection", data, (result) => {
    //   resolve(result);
    // });
    setTimeout(() => {
      resolve({ code: 200, message: "success", data: [], success: true });
    }, 0);
  });
};

// 检查批列表
export const newBatchListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.newBatchList", params, (result) => {
      resolve(result);
    });
  });
};

// 检查批编辑
export const newBatchEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.newBatchEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 构建裂损--列表
export const BuildingCracksListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.BuildingCracksList", params, (result) => {
      resolve(result);
    });
  });
};

// 构建裂损--编辑
export const BuildingCracksEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.BuildingCracksEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 构建变移--编辑
export const BuildingDisplacementEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.BuildingDisplacementEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 构建变移--列表
export const BuildingDisplacementListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.BuildingDisplacementList", params, (result) => {
      resolve(result);
    });
  });
};

// 裂损录入-列表
export const getInvestCracksList = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestCracksList", params, (result) => {
      resolve(result);
    });
  });
};

// 裂损录入-编辑
export const cracksEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.cracksEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 变移录入-列表
export const getInvestDisplacementList = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestDisplacementList", params, (result) => {
      resolve(result);
    });
  });
};

// 变移录入-编辑
export const displacementEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.displacementEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 检测-层高轴线-编辑层高
export const heightEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.heightEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 检测-层高轴线-列表
export const floorHeightAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.floorHeight", params, (result) => {
      resolve(result);
    });
  });
};

// 检测-轴线列表
export const axisListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.axisList", params, (result) => {
      resolve(result);
    });
  });
};

// 检测-轴线编辑
export const axisEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.axisEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 检测-删除轴线
export const deleteAxisMeasureAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.deleteAxisMeasure", data, (result) => {
      resolve(result);
    });
  });
};

// 构件检测/强度检测/强度检测详情（取芯）/强度检测详情（回弹）
export const constructionStrengthDetailAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.constructionStrengthDetail", params, (result) => {
      resolve(result);
    });
  });
};

// 构件检测/强度检测/强度检测编辑（取芯）/强度检测编辑（回弹）
export const constructionStrengthEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.constructionStrengthEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 构件检测/尺寸检测/编辑
export const sizeEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.sizeEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 构件检测/尺寸检测/详情
export const sizeInfoAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.sizeInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 构件检测/尺寸检测/删除
export const ConstructionDeleteAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.constructionDelete", data, (result) => {
      resolve(result);
    });
  });
};

// 率定编辑
export const calibrationEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.calibrationEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 率定信息
export const calibrationInfoAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.calibrationInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 批碳化深度
export const depthTransformationAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.depthTransformation", params, (result) => {
      resolve(result);
    });
  });
};

// 构件检测碳化
export const batchDetectionEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.batchDetectionEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 砂浆回弹/砂浆贯入/砂浆回弹/计算详情
export const calculationDetailsAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.calculationDetails", params, (result) => {
      resolve(result);
    });
  });
};

// 砂浆回弹/砂浆贯入/砂浆回弹/批推定
export const batchEstimationAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.batchEstimation", params, (result) => {
      resolve(result);
    });
  });
};

//  取芯抗压/离群值/详情
export const croingStrengthOutlierAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.croingStrengthOutlier", params, (result) => {
      resolve(result);
    });
  });
};

// 取芯抗压/离群值/计算离群值
export const croingStrengthCalculateOutlierAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.croingStrengthCalculateOutlier", data, (result) => {
      resolve(result);
    });
  });
};

// 取芯抗压/离群值/确定离群值
export const croingStrengthConfirmOutlierAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.croingStrengthConfirmOutlier", data, (result) => {
      resolve(result);
    });
  });
};

// 取芯抗压/芯样强度/芯样强度导出
export const croingStrengthExportAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.croingStrengthExport", params, (result) => {
      resolve(result);
    });
  });
};

// 取芯抗压/芯样强度/强度检测详情
export const croingStrengthAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.croingStrength", params, (result) => {
      resolve(result);
    });
  });
};

// 取芯抗压/芯样强度/芯样强度编辑
export const croingStrengthEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.croingStrengthEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 取芯抗压/芯样强度/芯样强度删除
export const croingStrengthDeletedAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.croingStrengthDeleted", data, (result) => {
      resolve(result);
    });
  });
};

// 调查------------------------------------------------------
// 建筑信息-详情
export const getInvestBuildInfo = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestBuildInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 工程信息-详情
export const engineerInfoDetailAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.engineerInfoDetail", params, (result) => {
      resolve(result);
    });
  });
};

// 工程信息-编辑
export const engineerInfoEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.engineerInfoEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 现场调查信息
export const getInvestigateDetectionInfo = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestigateDetectionInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 现场调查信息-编辑
export const getInvestigateEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestigateEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 现场调查信息-详情
export const getInvestigateAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestigate", params, (result) => {
      resolve(result);
    });
  });
};

// 建筑信息-编辑
export const buildInfoEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.buildInfoEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 方案------------------------------------------------------
// 获取选项
export const getInvestConfigList = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestConfigList", params, (result) => {
      resolve(result);
    });
  });
};

// 方案-详情
export const getInvestigateSchemeInfo = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestigateSchemeInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 方案-编辑
export const schemeInfoEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.schemeInfoEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 排查------------------------------------------------------------------------------------------
// 排查-报告列表
export const getInvestReportListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getInvestReportList", params, (result) => {
      resolve(result);
    });
  });
};

// 地基基础--场地--示例
export const SpaceExampleAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.SpaceExample", params, (result) => {
      resolve(result);
    });
  });
};

// 地基基础--场地--列表
export const SpaceListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.SpaceList", params, (result) => {
      resolve(result);
    });
  });
};

// 地基基础--场地--编辑
export const SpaceEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.SpaceEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 地基基础--地基基础--编辑
export const GroundFoundationEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.GroundFoundationEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 地基基础--地基基础--列表
export const GroundFoundationListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.GroundFoundationList", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-选择楼层配置项-构件变移楼层-列表
export const investListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.investList", params, (result) => {
      resolve(result);
    });
  });
};

// 地基基础--倾斜--列表
export const ShearingObliqueListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.ShearingObliqueList", params, (result) => {
      resolve(result);
    });
  });
};

// 地基基础--沉降--编辑
export const SettlementDetectionEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.SettlementDetectionEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 地基基础--沉降--列表
export const SettlementDetectionListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.SettlementDetectionList", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件裂损--编辑
export const ShearingObliqueEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.ShearingObliqueEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件裂损--列表
export const upperCracksListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.upperCracksList", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件变移--列表
export const upperDisplacementListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.upperDisplacementList", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件裂损--编辑
export const upperCracksEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.upperCracksEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件变移--编辑
export const upperDisplacementEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.upperDisplacementEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件裂损--列表
export const maintCracksListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.maintCracksList", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件裂损--编辑
export const maintCracksEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.maintCracksEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件变移--列表
export const maintDisplacementListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.maintDisplacementList", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件变移--编辑
export const maintDisplacementEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.maintDisplacementEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件裂损--列表
export const maintListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.maintListAndroid", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-上部构件裂损--编辑
export const maintEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.maintEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 排查-房间列表
export const roomListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.roomList", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-其他房间--列表
export const otherRoomListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.otherRoomList", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-其他房间--列表
export const newOtherRoomListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.newOtherRoomList", params, (result) => {
      resolve(result);
    });
  });
};

// 排查-其他房间--编辑
export const otherRoomEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.otherRoomEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-薄弱易塌-详情
export const WeakCollapseListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.WeakCollapseList", params, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-薄弱易塌-编辑
export const WeakCollapseEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.WeakCollapseEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-构件连接--详情
export const OverallConnectionListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.OverallConnectionList", params, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-构件连接--编辑
export const OverallConnectionEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.OverallConnectionEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-结构体系--详情
export const StructuralSystemInfoAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.StructuralSystemInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-结构体系--编辑
export const StructuralSystemEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.StructuralSystemEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-可靠性--列表
export const ReliabilityListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.ReliabilityList", params, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-可靠性--编辑
export const ReliabilityEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.ReliabilityEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-超限易损--详情
export const SuperFirmnessInfoAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.SuperFirmnessInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-超限易损--编辑
export const SuperFirmnessEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.SuperFirmnessEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-系统安全--详情
export const MaintsysSafeInfoAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.MaintsysSafeInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-系统安全--编辑
export const MaintsysSafeEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.MaintsysSafeEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-系统使用--详情
export const MaintsysUseInfoAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.MaintsysUseInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 抗震鉴定-系统使用--编辑
export const MaintsysUseEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.MaintsysUseEdit", data, (result) => {
      resolve(result);
    });
  });
};

// 报告列表
export const reportListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.reportList", params, (result) => {
      resolve(result);
    });
  });
};

// 构件详情
export const componentInfoAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.componentInfo", params, (result) => {
      resolve(result);
    });
  });
};

// 结构层高评定-编辑
export const floorHeightReportAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.floorHeightReport", data, (result) => {
      resolve(result);
    });
  });
};

// 结构层高评定-编辑
export const heightEditReportAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.heightEditReport", data, (result) => {
      resolve(result);
    });
  });
};

// 轴线尺寸评定-列表
export const axisListReportAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.axisListReport", params, (result) => {
      resolve(result);
    });
  });
};

// 轴线尺寸评定-编辑
export const axisEditReportAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.axisEditReport", data, (result) => {
      resolve(result);
    });
  });
};

// 检测复核-列表
export const detectionReportTableAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.detectionReportTable", params, (result) => {
      resolve(result);
    });
  });
};

// 构件尺寸评定-编辑
export const sizeReportEditAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.sizeReportEdit", data, (result) => {
      resolve(result);
    });
  });
};
// 获取APP离线地址
export const getLocalUrlAndroid = () => {
  if (dsBridge?.hasNativeMethod("rlkj.getLocalUrl")) {
    return dsBridge.call("rlkj.getLocalUrl") || "";
  }
  return "";
};

// 获取APP离线地址
export const getProjectConfig = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getProjectConfig", data, (result) => {
      resolve(result);
    });
  });
};

export const getAndroidConstructType = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getAndroidConstructType", data, (result) => {
      resolve(result);
    });
  });
};

// 项目编辑
export const androidconfigEdit = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidconfigEdit", data, (result) => {
      resolve(result);
    });
  });
};

export const androidearthquakeCategory = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidearthquakeCategory", data, (result) => {
      resolve(result);
    });
  });
};
export const androidmodifycrackdisplacement = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidmodifycrackdisplacement", data, (result) => {
      resolve(result);
    });
  });
};
export const androidgetReportModelList = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidgetReportModelList", data, (result) => {
      resolve(result);
    });
  });
};

export const androidgetReinforcementstretch = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidgetReinforcementstretch", data, (result) => {
      resolve(result);
    });
  });
};

export const androidgetReinforcementstretchReport = (data) => {
  return new Promise((resolve) => {
    dsBridge.call(
      "rlkj.androidgetReinforcementstretchReport",
      data,
      (result) => {
        resolve(result);
      }
    );
  });
};
export const androidupdreinforcementstretchReport = (data) => {
  return new Promise((resolve) => {
    dsBridge.call(
      "rlkj.androidupdreinforcementstretchReport",
      data,
      (result) => {
        resolve(result);
      }
    );
  });
};

export const androidstrengthIdentification = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidstrengthIdentification", data, (result) => {
      resolve(result);
    });
  });
};
export const androidgetStructuralSystem = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidgetStructuralSystem", data, (result) => {
      resolve(result);
    });
  });
};
export const androidupdateStructuralSystem = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidupdateStructuralSystem", data, (result) => {
      resolve(result);
    });
  });
};
export const androidgetOverallConnection = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidgetOverallConnection", data, (result) => {
      resolve(result);
    });
  });
};
export const androidupdateOverallConnection = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidupdateOverallConnection", data, (result) => {
      resolve(result);
    });
  });
};

export const androidgetpickstatus = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidgetpickstatus", data, (result) => {
      resolve(result);
    });
  });
};

export const androidgetpickstatusall = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidgetpickstatusall", data, (result) => {
      resolve(result);
    });
  });
};

export const newModelRoomListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.newModelRoomListAndroid", params, (result) => {
      resolve(result);
    });
  });
};
export const newModelRoomEditAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.newModelRoomEditAndroid", params, (result) => {
      resolve(result);
    });
  });
};
export const newOtherRoomSyncEditAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.newOtherRoomSyncEditAndroid", params, (result) => {
      resolve(result);
    });
  });
};
export const otherRoomSyncEditAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.otherRoomSyncEditAndroid", params, (result) => {
      resolve(result);
    });
  });
};
export const modelingSaveAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.modelingSaveAndroid", params, (result) => {
      resolve(result);
    });
  });
};
export const modelingListAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.modelingListAndroid", params, (result) => {
      resolve(result);
    });
  });
};
export const investReportLockAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.investReportLockAndroid", params, (result) => {
      resolve(result);
    });
  });
};
export const investReportUnlockAndroid = (params) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.investReportUnlockAndroid", params, (result) => {
      resolve(result);
    });
  });
};
export const androidEditReportMoel = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.androidEditReportMoel", data, (result) => {
      resolve(result);
    });
  });
};
export const confirmDeleteAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.confirmDelete", data, (result) => {
      resolve(result);
    });
  });
};
export const getDeviceLibListAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getDeviceLibListAndroid", data, (result) => {
      resolve(result);
    });
  });
};

export const editDevicesAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.editDevicesAndroid", data, (result) => {
      resolve(result);
    });
  });
};
export const getBuildingCrackListByGuidAndroid = (data) => {
  return new Promise((resolve) => {
    dsBridge.call("rlkj.getBuildingCrackListByGuidAndroid", data, (result) => {
      resolve(result);
    });
  });
};
